module.exports = __webpack_public_path__ + "static/media/Camera Icon.d3b836de.png";